
export default {
	props: {
		label: {
			type: String,
		},
		v: {
			type: Object,
			default: () => ({}),
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		id: null,
	}),
	mounted() {
		this.id = 'v-checkbox-' + this._uid + ''
	},
	methods: {
		checkboxChangeInputChangeHandler() {
			this.$nuxt.$emit('checkbox-input-changed', this.v.$model)
		},
	},
}
